import React from 'react';

function AdviceHeader() {
  return (
    <section className='padding-all'>
      <div className='blog-title'>
        <h3>Blog</h3>
        <h1 className='no-margin--bottom'>Advice</h1>
      </div>
    </section>
  );
}

export default AdviceHeader;
